<template>
    <modal
        name="batch-lock-confirm-modal"
        class="modal--translation"
        v-cloak
        height="auto"
        width="400px"
        :scrollable="false"
        :adaptive="true"
        :pivot-y="0.25"
        @before-open="beforeOpen"
        @before-close="beforeClose"
    >

        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0"><i class="fa fa-fw fa-lock mr-1"></i> {{ trans(actionUnlock ? 'title_unlock' : 'title') }}</h5>
        </div>

        <div class="modal-body p-0" :class="{'loading': loading }">

            <div v-if="selectedItems.length === 1 && employeeName !== null">
                <p>{{ trans(actionUnlock ? 'body_single_1_unlock' : 'body_single_1') }}
                   <b>{{ employeeName }}</b>
                   {{ trans('body_single_2') }} <b>{{ month }}/{{ year }}</b>?
                </p>
            </div>
            <div v-else>
                <p>{{ trans(actionUnlock ? 'body_multi_unlock' : 'body_multi') }}
                   <b>{{ month }}/{{ year }}</b>?
                </p>
            </div>

        </div>

        <div class="modal-footer text-center pt-4 d-flex justify-content-between">
            <div class="text-primary">
                <b v-if="loading">
                    <i class="fa fa-fw fa-span fa-spinner mr-2"></i>
                    {{ trans('processing') }}
                </b>
            </div>
            <b-button type="button" variant="primary" @click="submitForm()" :class="{'disabled': loading }"><i class="fa fa-check"></i> {{ trans('btn_submit') }}</b-button>
        </div>
    </modal>
</template>


<script>
    import TranslationsUtils from "../../app-components/TranslationsUtils";

    export default {
        mixins: [TranslationsUtils],
        props: {
            'url': {
                type: String
            },
            'year': {
                type: Number
            },
            'month': {
                type: Number
            },
            'onsuccess': {
                type: Function
            },
        },
        data: function() {
            return {
                action: 'lock',
                employeeName: null,
                selectedItems: [],
                loading: false
            };
        },

        methods: {
            beforeOpen: function(obj) {
                this.selectedItems = obj.params.ids;
                this.employeeName = obj.params.name ? obj.params.name : null;
                this.action = obj.params.action ? obj.params.action : 'lock';
            },

            // docs (example): https://github.com/euvl/vue-js-modal/blob/master/demo/src/components/Modal_Error.vue
            beforeClose(event) {
                if(this.loading) {
                    event.stop();
                    return false;
                }
            },

            submitForm() {
                let data = {
                    action: this.action,
                    employeeContractIds: this.selectedItems,
                    year: this.year,
                    month: this.month
                };
                this.loading = true;

                axios.post(this.url, data, { responseType: 'json' })
                    .then(() => {
                        this.$notify({ type: 'success', title: this.trans(this.actionUnlock ? 'processed_title_unlock' : 'processed_title') });
                        this.loading = false;
                        this.closeModal();
                        if(typeof this.onsuccess !== 'undefined') {
                            this.onsuccess();
                        }
                    })
                    .catch((response) => {
                        this.loading = false;
                        this.closeModal();
                        this.$notify({ type: 'error', title: 'Error!' });
                    });
            },

            closeModal() {
                this.$modal.hide('batch-lock-confirm-modal');
            }
        },

        computed: {
            actionUnlock: {
                get() {
                    return this.action === 'unlock';
                },
                set() {}
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    .head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .modal-body {
        line-height: 180%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/BatchLockConfirmDialog.vue